module.exports = __webpack_public_path__ + "static/media/Jenna Tala Headshot.194ee2c1.jpeg";